import { Identifiable, List } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function moveList(httpClient: HttpClient) {
  return (
    list: Identifiable<List>,
    parentList: Identifiable<List>,
    alignDates: boolean,
  ) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/projects/moveElement`,
        method: HttpMethods.POST,
        data: {
          elementUuid: list.uuid,
          projectEntityType: "ACTIVITY",
          targetActivityUuid: parentList.uuid,
          conserveTime: !alignDates,
        },
      })
      .catch((e) => {
        return Promise.reject(
          mapError(e, {
            startDateOutOfBoundProject: "startDateOutOfBoundProject",
            startDateOutOfBound: "startDateOutOfBound",
            endDateOutOfBoundProject: "endDateOutOfBoundProject",
            endDateOutOfBound: "endDateOutOfBound",
          }),
        );
      });
}

export { moveList };
